import { render, staticRenderFns } from "./ModalAccess.vue?vue&type=template&id=3c8fc3f1&lang=pug"
import script from "./ModalAccess.vue?vue&type=script&lang=js"
export * from "./ModalAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8fc3f1')) {
      api.createRecord('3c8fc3f1', component.options)
    } else {
      api.reload('3c8fc3f1', component.options)
    }
    module.hot.accept("./ModalAccess.vue?vue&type=template&id=3c8fc3f1&lang=pug", function () {
      api.rerender('3c8fc3f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalAccess.vue"
export default component.exports